angular.module('aq.filters.math')
.filter('percent', function() {
    return function(value, max) {
        return value / max * 100;
    }
});